class CustomZoneForwardingDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.datatable = this.init('#custom-zone-forwarding-datatable', organizationID);
        this.initActions(organizationID);
    }
    init(el, organizationID){
        const thisClass = this;
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[1, 'asc']],
            ajax: {
                url: '?do=getCustomZoneForwarding',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: 'row-selected-light-primary-bg'
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=custom-zone-forwarding-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">\n' +
                        '       <input class="form-check-input cursor-pointer" type="checkbox" data-kt-check="true" data-kt-check-target="'+el+' .form-check-input" data-kt-check-all="true" value="1"/>\n' +
                        '   </div>',
                    class: 'py-1',
                    sortable: false,
                    render: function (data, type, row) {
                        return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3">'+
                               '    <input class="form-check-input cursor-pointer" type="checkbox" value="'+row['uuid']+'" '+(!row['edit'] ? 'disabled' : '')+' />'+
                               '</div>';
                    }
                },
                {
                    data: 'zone',
                    title: 'Zone',
                    class: 'py-1',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span class="text-primary" data-zone="'+row['zone']+'">'+row['zone']+'</span>';
                    }
                },
                {
                    data: 'primary_ip',
                    title: 'Resolver IP (primary)',
                    class: 'py-1',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<div class="d-flex text-primary">'+
                                    row['primary_ip']+
                                (!row['isPrimaryValid'] ? '<i class="fa-solid fa-triangle-exclamation text-danger ms-2 fs-3" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="This Resolver IP is not functional as it is not in any Cloud/Branch subnet."></i>' : '')+
                                '</div>';
                    }
                },
                {
                    data: 'secondary_ip',
                    title: 'Resolver IP (secondary)',
                    class: 'py-1',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<div class="d-flex text-primary">'+
                            (row['secondary_ip'] ?? '')+
                            (!row['isSecondaryValid'] ? '<i class="fa-solid fa-triangle-exclamation text-danger ms-2 fs-3" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="This Resolver IP is not functional as it is not in any Cloud/Branch subnet."></i>' : '')+
                            '</div>';
                    }
                },
                {
                    data: 'status',
                    title: 'State',
                    class: 'py-1 pe-3 text-center',
                    sortable: true,
                    render: function (data, type, row) {
                        if(row['status']){
                            return '<i class="fa-solid fa-check fs-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Custom Zone Forwarding is synchronized with gateway.</div>"></i>';
                        } else {
                            return '<i class="fa-solid fa-xmark fs-2 text-danger" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Custom Zone Forwarding is not synchronized with gateway, please press Save Changes.</div>"></i>';
                        }
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    class: 'py-1 pe-3 text-center',
                    sortable: false,
                    render: function (data, type, row) {
                        if(row['edit']) {
                            return '<div class="datatable-action min-w-3" id="' + row['uuid'] + '">' +
                                '   <div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-custom-zone-forwarding cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">' +
                                '        <span class="svg-icon svg-icon-3">' +
                                '             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                  <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                  <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                  <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '              </svg>' +
                                '         </span>' +
                                '    </div>' +
                                '</div>';
                        }
                        return '';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#customZoneForwarding_wrapper [data-kt-docs-table-filter=search]').parent().hide();
                $('#custom-zone-forwarding-datatable_wrapper').hide();
            } else {
                $('#customZoneForwarding_wrapper [data-kt-docs-table-filter=search]').parent().show();
                $('#custom-zone-forwarding-datatable_wrapper').show();
            }
        }).on('draw', function () {
            thisClass.removeSelectedRows(organizationID);
            $('#custom-zone-forwarding-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            if(datatable.page.info().recordsTotal !== 0){
                $('#custom-zone-forwarding-datatable_wrapper').show();
                $('#customZoneForwarding_wrapper [data-kt-docs-table-filter=search]').parent().show();
            }
            const container = document.querySelector('#customZoneForwarding_wrapper');
            const baseToolbar = container.querySelector('[data-kt-docs-table-toolbar="base"]');
            const selectedToolbar = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
            if(selectedToolbar){
                selectedToolbar.classList.add('d-none');
            }
            if(baseToolbar){
                baseToolbar.classList.remove('d-none');
            }
            
        }).on('select', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows === displayedRows){
                $('#custom-zone-forwarding-datatable_wrapper [data-kt-check-all]').prop('checked', true);
            }
        }).on('deselect', function () {
            let selectedRows = thisClass.datatable.rows({selected:true}).count();
            let displayedRows = thisClass.datatable.rows({page:'current'} ).count();
            if(selectedRows !== displayedRows){
                $('#custom-zone-forwarding-datatable_wrapper [data-kt-check-all]').prop('checked', false);
            }
        });
        // Add delay to datatable search
        new DatatableSearchDelay(datatable, '#dns_management_tab [data-kt-docs-table-filter=search]');
        return datatable;
    }
    initActions(organizationID){
        const thisClass = this;
        /** Select All rows */
        $(document).on('click','#custom-zone-forwarding-datatable_wrapper [data-kt-check-all]',function(e){
            if ($(this).is(':checked')) {
                thisClass.datatable.rows().select();
            } else {
                thisClass.datatable.rows().deselect();
            }
        });

        $(document).on('click','.delete-custom-zone-forwarding',function(e){
            let customZoneForwardingID = $(this).parent()[0].id;
            let zone = $(this).closest('tr').find('span[data-zone]').attr('data-zone');
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to delete `+(zone !== undefined ? `<b>`+zone+`</b>` : `this Custom Zone Forwarding`)+`?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/threat-blocker-and-dns?do=removeCustomZoneForwarding&organizationID='+organizationID+'&customZoneForwardingID='+customZoneForwardingID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        // Set Save Changes button active
                        let saveChangesBtn = document.getElementById('saveChangesBtn');
                        if(saveChangesBtn){
                            saveChangesBtn.disabled = false;
                            let pulseBtn = document.getElementById('saveChangesPulse');
                            if(!pulseBtn){
                                let pulseBtn = document.createElement("span");
                                pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                                pulseBtn.id = 'saveChangesPulse';
                                saveChangesBtn.appendChild(pulseBtn);
                            }
                        }
                        new LeavePageDialog(true);
                        toastr.success('Custom Zone Forwarding has been deleted.');
                        thisClass.datatable.ajax.reload(null, false);
                    }
                }
            });
        });
    }
    removeSelectedRows(organizationID){
        const thisClass = this;
        // Toggle selected action toolbar
        // Select all checkboxes
        const container = document.querySelector('#customZoneForwarding_wrapper');
        const checkboxes = container.querySelectorAll('[type="checkbox"]');

        // Select elements
        const deleteSelected = container.querySelector('[data-kt-docs-table-select="delete_selected"]');

        // Toggle delete selected toolbar
        checkboxes.forEach(c => {
            // Checkbox on click event
            c.addEventListener('click', function () {
                setTimeout(function () {
                    thisClass.toggleToolbars();
                }, 50);
            });
        });

        // Deleted selected rows
        if(deleteSelected) {
            deleteSelected.addEventListener('click', function () {
                let customZoneForwardingIDs = thisClass.getSelectedIDs();
                Swal.fire({
                    html: `<span class="text-center text-primary">Are you sure you want to delete selected Custom Zone Forwarding?</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                returnFocus: false,
                    preConfirm: () => {
                        return fetch('/threat-blocker-and-dns?do=removeCustomZoneForwarding&organizationID=' + organizationID + '&customZoneForwardingID=' + customZoneForwardingIDs)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        const headerCheckbox = container.querySelectorAll('[type="checkbox"]')[0];
                        headerCheckbox.checked = false;
                        container.querySelector('[data-kt-docs-table-toolbar="base"]').classList.remove('d-none');
                        container.querySelector('[data-kt-docs-table-toolbar="selected"]').classList.add('d-none');
                        if (result.value === 'deleted') {
                            // Set Save Changes button active
                            let saveChangesBtn = document.getElementById('saveChangesBtn');
                            if(saveChangesBtn){
                                saveChangesBtn.disabled = false;
                                let pulseBtn = document.getElementById('saveChangesPulse');
                                if(!pulseBtn){
                                    let pulseBtn = document.createElement("span");
                                    pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                                    pulseBtn.id = 'saveChangesPulse';
                                    saveChangesBtn.appendChild(pulseBtn);
                                }
                            }
                            new LeavePageDialog(true);
                            toastr.success('Domain has been deleted.');
                            thisClass.datatable.ajax.reload(null, false);
                        }
                    }
                });
            });
        }
    }
    toggleToolbars() {
        // Define variables
        const container = document.querySelector('#customZoneForwarding_wrapper');
        const toolbarBase = container.querySelector('[data-kt-docs-table-toolbar="base"]');
        const toolbarSelected = container.querySelector('[data-kt-docs-table-toolbar="selected"]');
        if(toolbarBase && toolbarSelected){
            const selectedCount = container.querySelector('[data-kt-docs-table-select="selected_count"]');

            // Select refreshed checkbox DOM elements
            const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

            // Detect checkboxes state & count
            let checkedState = false;
            let count = 0;

            // Count checked boxes
            allCheckboxes.forEach(c => {
                if (c.checked) {
                    checkedState = true;
                    count++;
                }
            });

            // Toggle toolbars
            if (checkedState) {
                selectedCount.innerHTML = count;
                toolbarBase.classList.add('d-none');
                toolbarSelected.classList.remove('d-none');
            } else {
                toolbarBase.classList.remove('d-none');
                toolbarSelected.classList.add('d-none');
            }
        }
    }
    getSelectedIDs(){
        // Define variables
        const container = document.querySelector('#customZoneForwarding_wrapper');
        // Select refreshed checkbox DOM elements
        const allCheckboxes = container.querySelectorAll('tbody [type="checkbox"]');

        let ids = [];

        // Count checked boxes
        allCheckboxes.forEach(c => {
            if (c.checked) {
                ids.push(c.value);
            }
        });
        return ids;
    }
}
window.CustomZoneForwardingDatatable = CustomZoneForwardingDatatable;